import "../styles/default.scss";

import classNames from "classnames";
import React from "react";
import { compose } from "redux";

import withBottomNavigation from "../../../../../hocs/withBottomNavigation";
import withNavbarHeight from "../../../../../hocs/withNavbarHeight";
import withNotifications from "../../../../../hocs/withNotifications";
import NotificationsMobile from "../../../landingPage/pages/Notifications/components/notificationsMobile/NotificationsMobile";

const MobileNotificationList = props => {
  const { setValue, canDisplayVerifyEmailBar } = props;
  const bottomMenuHeight = 50;

  const footerHeight = canDisplayVerifyEmailBar
    ? bottomMenuHeight + 26
    : bottomMenuHeight;

  return (
    <div
      className={classNames("mobile-notification-list")}
      style={{
        height: `calc(100% - ${footerHeight}px)`
      }}
    >
      <NotificationsMobile {...props} onToggle={setValue} />
    </div>
  );
};

export default compose(
  withNotifications,
  withBottomNavigation(),
  withNavbarHeight
)(MobileNotificationList);
